/**
 * HAS SINGLE PERMISSION
 */
export function can(userPermissions = [], permission) {
  if (!permission) {
    return true;
  }

  if (!Array.isArray(userPermissions)) {
    return false;
  }

  return userPermissions.includes(permission);
}

/**
 * HAS ANY PERMISSION
 */
export function hasAnyPermission(userPermissions = [], permissions = []) {
  if (!Array.isArray(userPermissions)) {
    return false;
  }

  if (!Array.isArray(permissions)) {
    return false;
  }

  return permissions.some((permission) => userPermissions.includes(permission));
}

/**
 * HAS ALL PERMISSIONS
 */
export function hasAllPermissions(userPermissions = [], permissions = []) {
  if (!Array.isArray(userPermissions)) {
    return false;
  }

  if (!Array.isArray(permissions)) {
    return false;
  }

  return permissions.every((permission) =>
    userPermissions.includes(permission),
  );
}
